import { render, staticRenderFns } from "./ScreenSolicitudVerificaciones.vue?vue&type=template&id=5785e851"
import script from "./ScreenSolicitudVerificaciones.vue?vue&type=script&lang=js"
export * from "./ScreenSolicitudVerificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports